import React, { useState, useContext } from 'react';
import { AppContext } from '~/providers/AppProvider';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import PriceFilter from '~/components/filter/priceFilter';
import BoatSizeFilter from '~/components/filter/boatSizeFilter';
import InstantBookableFilter from '~/components/filter/instantBookableFilter';
import { Button } from '@boatsetter-backup/js-component-lib';
import { defaultBoatSearchOptions, defaultFilterValues } from '~/api/config';
import { Trans } from '@lingui/react';

const MoreFilters = ({ setShoMoreFilters }) => {
  const router = useRouter();
  const appCtx = useContext(AppContext);

  const getChecked = () => {
    if (router.query.isInstantBookable === undefined) {
      return defaultBoatSearchOptions.isInstantBookable;
    } else {
      return router.query.isInstantBookable === 'true';
    }
  };
  const [checked, setChecked] = useState(getChecked());

  const [maxPrice, setMaxPrice] = useState(
    router.query.priceTo === undefined ? defaultFilterValues.maxPrice : parseInt(String(router.query.priceTo))
  );

  const [minPrice, setMinPrice] = useState(
    router.query.priceFrom === undefined ? defaultBoatSearchOptions.priceFrom : parseInt(String(router.query.priceFrom))
  );

  const [maxSize, setMaxSize] = useState(
    router.query.boatSizeTo === undefined ? defaultFilterValues.maxBoatSize : parseInt(String(router.query.boatSizeTo))
  );

  const [minSize, setMinSize] = useState(
    router.query.boatSizeFrom === undefined
      ? defaultBoatSearchOptions.boatSizeFrom
      : parseInt(String(router.query.boatSizeFrom))
  );

  const clearSearch = () => {
    setShoMoreFilters(false);

    const currentQueries = router.query;

    delete currentQueries.priceFrom;
    delete currentQueries.priceTo;
    delete currentQueries.boatSizeFrom;
    delete currentQueries.boatSizeTo;
    delete currentQueries.isInstantBookable;
    delete currentQueries.pageNumber;

    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...currentQueries,
        },
      },
      undefined,
      { scroll: false }
    );
    setShoMoreFilters(false);
  };

  const makeSearch = () => {
    setShoMoreFilters(false);
    appCtx.actions.setLoading(true);

    const newQuery = router.query;
    delete newQuery.pageNumber;

    newQuery.boatSizeFrom = String(minSize);
    newQuery.boatSizeTo = String(maxSize);
    newQuery.priceFrom = String(minPrice);
    newQuery.priceTo = String(maxPrice);
    newQuery.isInstantBookable = String(checked);

    if (maxSize === defaultFilterValues.maxBoatSize) {
      delete newQuery.boatSizeTo;
    }

    if (maxPrice === defaultFilterValues.maxPrice) {
      delete newQuery.priceTo;
    }

    if (minPrice === defaultBoatSearchOptions.priceFrom) {
      delete newQuery.priceFrom;
    }

    if (minSize === defaultBoatSearchOptions.boatSizeFrom) {
      delete newQuery.boatSizeFrom;
    }

    if (router.query.isInstantBookable === undefined || router.query.isInstantBookable === 'false') {
      delete newQuery.isInstantBookable;
    }

    router.replace(
      {
        pathname: router.pathname,
        query: newQuery,
      },
      undefined,
      { scroll: false }
    );

    setShoMoreFilters(false);
  };

  return (
    <Wrapper>
      <FiltersWrapper>
        <InstantBookableFilter checked={checked} setChecked={setChecked} />
        <Divider />
        <PriceFilter maxPrice={maxPrice} minPrice={minPrice} setMaxPrice={setMaxPrice} setMinPrice={setMinPrice} />
        <Divider />
        <BoatSizeFilter maxSize={maxSize} minSize={minSize} setMaxSize={setMaxSize} setMinSize={setMinSize} />
      </FiltersWrapper>

      <FilterBottomBar>
        <Clear onClick={clearSearch}>
          <Trans id="moreFilters.clearAll" />
        </Clear>
        <Button small={true} onClick={makeSearch} text={<Trans id="moreFilters.seeResults" />} />
      </FilterBottomBar>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 450px;
  max-height: 77vh;
  position: absolute;
  background-color: white;
  border: 1px solid #dbdfe5;
  box-sizing: border-box;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  top: 55px;
  display: flex;
  flex-direction: column;

  @media (max-width: 960px) {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    width: 92%;
    overflow-x: hidden;
  }
`;

const FiltersWrapper = styled.div`
  padding: 3em;
`;

const Divider = styled.div`
  border: 1px solid rgb(219, 223, 229);
  width: 100%;
  height: 1px;
  margin-top: 2em;
  margin-bottom: 2em;
`;

const FilterBottomBar = styled.div`
  padding: 0 2em;
  height: 90px;
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  left: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 5px 22px -2px rgba(0, 0, 0, 0.2);

  button span {
    font-size: 12px !important;
    font-family: AvenirNext, Avenir, Helvetica Neue, Helvetica, Arial, sans-serif;
  }
`;

const Clear = styled.div`
  font-size: 1em;
  line-height: 1.6;
  color: #0751c2;
  cursor: pointer;
`;
export default MoreFilters;
